export default ["🥰", "😍", "🥹", "😬", "😱", "🤗", "🥹", "🤤", "🤩", "😚", "😋", "😁"];
